import { fdrBlogCriteria } from 'components/util/criterias/blog.dmc';
import { fdrFullScreenHeroCriteria } from 'components/util/criterias/hero.dmc';
import { fdrMarketingRecommendation } from 'components/util/criterias/marketingRecommendation.dmc';
import {
  fdrMediaFull,
  fdrMediaPreview,
} from 'components/util/criterias/media.dmc';

export const fdrThemeGeoPageVars = {
  heroCriteria: fdrFullScreenHeroCriteria,
  themeGeoProductInput: {
    pagination: {
      page: 0,
      perPage: 9,
    },
  },
  themeGeoPagesRecommenderInput: {
    pagination: {
      page: 0,
      perPage: 12,
    },
  },
};

export const fdrThemeGeoPageComponentsVars = {
  heroCriteria: fdrFullScreenHeroCriteria,
  mediaFull: fdrMediaFull,
  mediaPreview: fdrMediaPreview,
  blogCriteria: fdrBlogCriteria,
  fdrMarketing: fdrMarketingRecommendation,
  pageComponentsInput: { pagination: { page: 0, perPage: 100 } },
};
